import React from 'react';

class AssetCategory extends React.Component {
    handlePickAsset = (assetData) => {
        const { onPickAsset } = this.props;
        onPickAsset(assetData);
    }

    createList = () => {
        const { assets, currentAsset, AssetComponent } = this.props;
        const list = [];

        for(let i = 0; i < assets.length; ++i) {
            const assetEntry = assets[i];
            list.push(
                <AssetComponent
                    key={i}
                    entry={assetEntry}
                    currentAsset={currentAsset}
                    onPickAsset={this.handlePickAsset}
                />
            );
             
        }

        return list;
    }

    render = () => {
        const items = this.createList();

        return (
            <>
                {
                    items
                }
            </>
        )
    }
}

export default AssetCategory;